import styled from '@emotion/styled';

import { ButtonBase } from 'components/buttons/ButtonBase';

export const ButtonSlimLink = styled(ButtonBase)`
  background: transparent;

  &,
  &.MuiButton-root.Mui-disabled {
    color: ${({ theme }) => theme.colors.action};
  }

  &:hover {
    background: transparent;
    text-decoration: underline;
  }
`;
